import script from "./ProjectDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectDetails.vue?vue&type=script&setup=true&lang=js"

import "./ProjectDetails.vue?vue&type=style&index=0&id=058e49a0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-058e49a0"]])

export default __exports__